<template>
  <div>
    <div class="container-fluid right_wrapper">
      <AddCampaignHeader></AddCampaignHeader>
      <AddCampaignForm class="table_wrap no_footer pt-2"></AddCampaignForm>
    </div>
    <!-- Modal Starts -->
  </div>
</template>

<script>
import AddCampaignHeader from "@/components/add-campaign/AddCampaignHeader";
import AddCampaignForm from "@/components/add-campaign/AddCampaignForm";

export default {
  components: {
    AddCampaignHeader,
    AddCampaignForm,
  },
};
</script>

<style lang="scss"></style>
